import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Survey, SurveyMainComponent, SurveyStatus } from '@brightside-web/desktop/feature/survey-questionnaire';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingStepsService } from '@brightside-web/desktop/feature/onboarding2';

@Component({
    selector: 'brightside-web-onboarding-survey',
    imports: [CommonModule, SurveyMainComponent],
    templateUrl: './onboarding-survey.component.html',
    styleUrl: './onboarding-survey.component.css'
})
export class OnboardingSurveyComponent {

  readonly _router = inject(Router);
  readonly _route = inject(ActivatedRoute);
  readonly _onboardingStepsService = inject(OnboardingStepsService)

  onSurveyStatus(surveyData: Survey) {
    if (surveyData) {
      if (surveyData.status === SurveyStatus.COMPLETED) {
        this._onboardingStepsService.completeStep();
      } else if (surveyData.status === SurveyStatus.TERMINATED) {
        this._onboardingStepsService.failStep();
      } else if (!this._router.url.endsWith('/view')) {
        this._router.navigate(['view'], { relativeTo: this._route });
      }
    }
  }
}
